import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { ReducedParams } from '@api/order-reporting/types/ReducedParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingReducedMaterials.gridData;
export const selectDateRange = (state: RootState) => state.reportingReducedMaterials.dateRange;
export const selectSelectedPlant = (state: RootState) => state.reportingReducedMaterials.selectedPlant;
export const selectOrderPhase = (state: RootState) => state.reportingReducedMaterials.orderPhase;
export const selectShowReasonColumn = (state: RootState) => state.reportingReducedMaterials.showReasonColumn;



export const selectValidParams = createSelector(
	[
		selectDateRange,
		selectSelectedPlant,
		selectOrderPhase,
	],(
		dateRange: DateRange | null,
		selectedPlant: string | null,
		orderPhase: string | null,
	) => {
		if (!dateRange) return null;
		let validParams: ReducedParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
			...(selectedPlant && { dc: selectedPlant }),
			...(orderPhase && { orderPhase: orderPhase }),
		};
		return validParams;
	}
);